(function() {
  function handleScroll(entries) {
    const nav = document.querySelector('.banner .nav')
    
    entries.forEach(entry => {
      if(!entry.isIntersecting || entry.intersectionRatio < 1) {
        nav.classList.add('scrolled')
      } else {
        nav.classList.remove('scrolled')
      }
    })
  }
  
  function observeScroll() {
    const windowWidth = checkWidth()

    if(windowWidth > 1200) {
      const observer = new IntersectionObserver(handleScroll, { threshold: 1 })
    
      const banner = document.querySelector('.banner')
      observer.observe(banner)
    }
  }

  function checkWidth() {
    return document.body.clientWidth
  }

  window.addEventListener('DOMContentLoaded', observeScroll)
  window.addEventListener('resize', observeScroll)
})()